import { Box } from "@mui/material"
import { useContext } from "react"

import CompanyContext 	from "../context"
import Loading 			from "../../../components/Loading";
import Forum 			from "../../../components/Forum";

const PanelForum = () => {

	const { company }								= useContext(CompanyContext)

	if (!company) return <Loading/>

	return (
		<Box sx={{pt: 1, paddingX: 2, marginBottom: 5}}>
			<Forum companyId={company.id} />
		</Box>
	)	
}

export default PanelForum